import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_ATTEMPTS = 30;
const INTERVAL_MS = 2000;

const resolveStatus = (data) => {
  if (data.payment_status === 'paid') return 'paid';
  if (data.payment_status === 'expired' || data.status === 'expired') return 'expired';
  return null;
};

export const usePaymentStatus = (sessionId) => {
  const [status, setStatus] = useState(sessionId ? 'polling' : 'error');

  useEffect(() => {
    if (!sessionId) return undefined;
    let attempts = 0;
    let timer;
    let cancelled = false;

    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        const next = resolveStatus(data);
        if (next && !cancelled) { setStatus(next); return; }
      } catch (err) {
        console.error('Payment status poll failed', err);
      }
      if (cancelled) return;
      if (attempts >= MAX_ATTEMPTS) { setStatus('expired'); return; }
      timer = setTimeout(poll, INTERVAL_MS);
    };

    poll();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [sessionId]);

  return status;
};
